import { render, staticRenderFns } from "./Scrolling.vue?vue&type=template&id=721c821a"
import script from "./Scrolling.vue?vue&type=script&lang=js"
export * from "./Scrolling.vue?vue&type=script&lang=js"
import style0 from "./Scrolling.vue?vue&type=style&index=0&id=721c821a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports